import { toMinorUnits } from "@tovi/shared";

/**
 * A decimal somebody is still typing, as minor units, or null while it is not
 * a number yet.
 *
 * `toMinorUnits` throws on anything its pattern does not match, which is
 * right for a value about to be sent — but a cashier mid-keystroke has typed
 * `1..` more often than not, and that must never be an error, only "no answer
 * yet".
 */
export function typedMinorUnits(text: string, currency: string): bigint | null {
  const trimmed = text.trim();
  if (trimmed === "") return null;
  try {
    return BigInt(toMinorUnits(trimmed, currency));
  } catch {
    return null;
  }
}
